import React from 'react'
import { FormGroup, FormHelperText } from '@mui/material'
import Checkbox from 'redesign/components/atoms/Checkbox'
import Headline from 'redesign/components/atoms/Headline'
import { ZERO } from 'shared/constants'
import { Container } from './styles'
import type { CheckboxFormGroupProps } from './types'

const CheckboxFormGroup: React.FC<CheckboxFormGroupProps> = ({
  checkboxes = [],
  disabled,
  error,
  helperText,
  legend,
  size = 'medium',
}) => (
  <Container disabled={disabled} error={error}>
    {legend && <Headline text={legend} horizontalSpacing={ZERO} />}
    <FormGroup>
      {checkboxes.map((props) => (
        <Checkbox size={size} {...props} key={`${props?.key}`} />
      ))}
    </FormGroup>
    {helperText && <FormHelperText>{helperText}</FormHelperText>}
  </Container>
)

export default CheckboxFormGroup
